export const AudioDisplay = ({ file, isShowName = true }) => {
  // 🎯 處理檔案業務物件格式兼容性
  const displayFile = {
    id: file.fileId || file.id,
    fileName: file.fileName || file.name,
    url: file.url,
    content_type: file.content_type || file.type,
    ...file
  };

  return (
    <div className="text-sm font-medium">
      {isShowName && <div className="mb-2">{displayFile.fileName}</div>}
      <audio
        controls
        className="w-full"
        key={displayFile.id}
      >
        <source
          src={displayFile.url}
          type={displayFile.content_type}
        />
        您的瀏覽器不支援音訊播放
      </audio>
    </div>
  )
}